import { useState } from "react"
import "./register.css"
import { useNavigate } from "react-router-dom"
import { handleRegister } from "../../requests/userRequests"
import { useGlobalContext } from "../../context"
import { Link } from "react-router-dom"

function Register() {
    const navigate = useNavigate()
    const { handleErr } = useGlobalContext()
    const [user, setUser] = useState({
        username: "",
        phoneNumber: "",
        password: ""
    })
    // 7304
    const handleSubmit = async (e) => {
        e.preventDefault()
        const res = await handleRegister(user)
        handleErr(res.type, res.massage)
        if (res.type == "success") {
            navigate("/login")
        }
    }
    return (
        <div className="register">
            <div className="register-container">
                <div className="grid">
                    <form onSubmit={(e) => handleSubmit(e)} className="form login">
                        <div className="form__field">
                            <input onChange={(e) => setUser({ ...user, username: e.target.value })} id="login__username" type="text" name="username" className="form__input" placeholder="نام کاربری" required />
                        </div>

                        <div className="form__field">
                            <input onChange={(e) => setUser({ ...user, phoneNumber: e.target.value })} id="login__password" type="text" name="phoneNumber" className="form__input" placeholder="شماره تلفن" required />
                        </div>

                        <div className="form__field">
                            <input onChange={(e) => setUser({ ...user, password: e.target.value })} id="login__password" type="password" name="password" className="form__input" placeholder="رمز" required />
                        </div>

                        <div className="form__field">
                            <input type="submit" value="ثبت نام" />
                        </div>
                        <Link to={"/login"}>ورود</Link>
                    </form>
                </div>
            </div>
        </div>
    )
}
export default Register;